import { ProfileMigration } from "../../../features/profile/types/profile-migration/profile-migration.entity";
import { apiClientMainV2 } from "../../../lib/client-api";
import { Mapper } from "../../../lib/utils/mapper";
import { Profile } from "../../../types/profile/profile.entity";
import type { IProfileMigrationDto } from "./dto/profile-migration.dto.interface";
import { ProfileMigrationDto } from "./dto/profile-migration.dto";
import { ProfileDto } from "./dto/profile.dto";

const PROFILE_ENDPOINT = "/profile/";
const PROFILE_MIGRATION_ENDPOINT = "/profile/migration";

export async function getCurrentProfile(): Promise<Profile> {
  const response = await apiClientMainV2.get<ProfileDto>(PROFILE_ENDPOINT);

  const dto = Mapper.mapData(ProfileDto, response.data);
  const entity = Mapper.mapData(Profile, dto);

  return entity;
}

export async function getCurrentProfileMigration(): Promise<ProfileMigration> {
  const response = await apiClientMainV2.get<IProfileMigrationDto>(PROFILE_MIGRATION_ENDPOINT);

  const dto = Mapper.mapData(ProfileMigrationDto, response.data);
  const entity = Mapper.mapData(ProfileMigration, dto);

  return entity;
}
